import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'lib-optix-lib',
  template: `
    <div>{{data | date}}</div>
   `,
  styles: []
})

//  <optix-calendar [apiKey]="apiKey" [storeId]="storeId" [contact]="contact"></optix-calendar>
export class OptixLibComponent implements OnInit {

  @Input() apiKey = null;
  @Input() storeId = null;
  @Input() contact: any;

  data = new Date();

  constructor(private t: TranslateService) {
    this.t.setTranslation('it', {
        buttons: {
          send: 'Invia',
          confirm: 'Conferma',
          next: 'Avanti',
          back: 'Indietro'
        },
        stepper: {
          title: 'Prenotazione',
          appointment: 'Appuntamento',
          date: 'Data',
          hour: 'Ora',
          info: 'Contatti'
        },
        appointmenttypes: {
          title: 'Seleziona l\'appuntamento',
          selectstore: 'Scegli il negozio',
          selectappointment: 'Tipo di appuntamento',
          eyecontrol: 'Controllo vista',
          lactest: 'Prova Lac',
          order: 'Ritiro ordine'
        },
        noapikey: {
          title: 'Api key assente o non valida!',
          subtitle: 'Devi possedere una api key valida per usare il calendario.'
        },
        error: {
          title: 'Ops, qualcosa è andato storto!',
          subtitle: 'Ricarica la pagina o contatta un amministratore se l\'errore persiste',
          required: 'Campo obbligatorio',
          mail: 'Non hai inserito un indirizzo valido',
          selectappointment: 'Seleziona il tipo di appuntamento',
          selectstore: 'Seleziona il negozio'
        },
        calendar: {
          title: 'Seleziona la data'
        },
        hour: {
          title: 'Seleziona l\'ora'
        },
        contact: {
          title: 'Richiesta contatti',
          labels: {
            name: 'Nome',
            email: 'Indirizzo email',
            phone: 'Telefono',
            addinfo: 'Informazioni aggiuntive'
          }
        },
        confirmation: {
          title: 'Richiesta inviata',
          subtitle: 'Perfetto, abbiamo ricevuto la tua richiesta',
          confirm: 'Attendi che un nostro operatore confermi la tua richiesta.\nTi risponderemo nel minor tempo possibile.'
        }
      }, true
    );
  }

  ngOnInit(): void {
  }

}
